import type { AcceptInviteCommand, AcceptInvitePersonCommand, AcceptInviteResult, InvitePreview } from "@/domain/model/Invitation";
import type { AcceptInviteDto, AcceptInvitePersonDto, AcceptInviteResultDto, InvitePreviewDto } from "../dto/InvitationDto";
import { toRequiredDate, mapAccountUserRole, mapAcceptInviteNextAction } from "./util";

export function mapInvitePreviewDtoToModel(
  dto: InvitePreviewDto
): InvitePreview {
  return {
    email: dto.email,
    role: dto.role,
    expiresAt: toRequiredDate(dto.expiresAt, "expiresAt"),
    requiresPerson: dto.requiresPerson
  }
}

export function mapAcceptInvitePersonCommandToDto(
cmd: AcceptInvitePersonCommand
): AcceptInvitePersonDto {
   return {
     displayName: cmd.displayName,
     preferredName: cmd.preferredName ?? null,
     mobilePhoneE164: cmd.mobilePhoneE164 ?? null,
     canAppearInPhoto: cmd.canAppearInPhoto
   }
}

export function mapAcceptInviteCommandToDto(
  cmd: AcceptInviteCommand
): AcceptInviteDto {
  return {
    token: cmd.token,
    password: cmd.password,
    person: cmd.person != null
    ? mapAcceptInvitePersonCommandToDto(cmd.person)
    : null,
    acceptedUserTermsVersion: cmd.acceptedUserTermsVersion,
    acceptedPrivacyVersion: cmd.acceptedPrivacyVersion
  }
}

export function mapAcceptInviteResultDtoToModel(
  dto: AcceptInviteResultDto
): AcceptInviteResult {
  return {
    accountId: dto.accountId,
    userId: dto.userId,
    personId: dto.personId,
    role: mapAccountUserRole(dto.role),
    nextAction: mapAcceptInviteNextAction(dto.nextAction),

    accessToken: dto.accessToken ?? undefined,
    accessExpiresAt: dto.accessExpiresAt ?? undefined
  }
}
